<template>
    <div>
        <Sidebar></Sidebar>
        <!-- Modals -->
        <ExemptionEvaluation :modalTitle="'Rejeter et archiver la demande'"
                         :fieldName="'Motif du refus'"
                         :isAbort="false"
                         :showModal.sync="showModal"
                         :exemption.sync="exemption"
        ></ExemptionEvaluation>
        <ConfirmationModal :showModal.sync="showConfirmationModal"
                           :question="'Veuillez confirmer la validation de cette demande de dispense ?'"
                           :closeButtonText="'Retour à l\'appréciation'"
                           :confirmButtonText="'Confirmer la validation'"
                           v-on:confirmApprove="approve"
        ></ConfirmationModal>
        <!-- Modals -->

        <div class="content-wrapper appreciation-content-wrapper">
            <div class="img-desktop d-none d-lg-inline-block img-desktop-appreciation"></div>
            <Header></Header>

            <section class="content content-appreciation">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col form-request-content-appreciation">
                            <div class="request-title">
                                <h1>Appréciation d'une demande</h1>
                            </div>

                            <div class="label-update">
                                <article class="contain-label">
                                    <label> Nom: </label>
                                    <p class="label-p" v-if="exemption">
                                        {{ exemption.civility }} {{ exemption.firstName }} {{ exemption.lastName }}
                                    </p>
                                </article>
                                <article class="contain-label">
                                    <label> Motif: </label>
                                    <img src="@/assets/img/orangePill.svg" class="orangePillAppreciation">
                                    <p class="label-p" v-if="reason">
                                        {{ reason.titleHro }}
                                    </p>
                                </article>
                            </div>
                            <!-- .label-update -->

                            <div class="col-11 info-card info-card-appreciation card-appreciation__item" v-if="legalInformation">
                                <div class="card-appreciation__content">
                                    <div class="intro">{{ legalInformation.requestTitle }}</div>
                                    <div class="intro-item-2">{{ legalInformation.requestDescription }}</div>
                                    <article v-for="(requestItem, index) in legalInformation.requestItems" :key="index">
                                       <p>{{ requestItem }}</p>
                                    </article>
                                </div>
                                <div class="form-group button-container card-appreciation__buttons">
                                    <button
                                        v-if="hasReasonFile('SD0')"
                                        type="button"
                                        class="download-btn"
                                        @click.prevent="downloadFileByCode('SD0')"
                                    >
                                        Afficher la pièce justificative
                                    </button>
                                    <button
                                        v-else
                                        type="button"
                                        class="download-btn disabled"
                                        title="Justificatif manquant"
                                        disabled
                                    >
                                        Ce justificatif est manquant
                                    </button>
                                </div>
                            </div>
                            <!-- /.info-card -->

                            <div class="col-11 info-card info-card-appreciation" v-if="legalInformation && reason">
                                <div class="intro">Pièce(s) justificative(s)</div>
                                <div class="intro-item-2">Quelles pièces justificatives ?</div>
                                <div class="card-appreciation__item card-appreciation__item_docs" v-for="docItem in documentTypes" :key="docItem.typeCode">
                                    <article>
                                        <p> {{ docItem.title }} </p>
                                    </article>

                                    <div class="form-group button-container">
                                        <button
                                            v-if="hasReasonFile(docItem.code)"
                                            type="button"
                                            class="download-btn"
                                            @click.prevent="downloadFileByCode(docItem.code)"
                                        >
                                            Afficher la pièce justificative
                                        </button>
                                        <button
                                            v-else
                                            type="button"
                                            class="download-btn disabled"
                                            title="Justificatif manquant"
                                            disabled
                                        >
                                            Ce justificatif est manquant
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <!-- /.info-card -->

                            <div class="col-11 info-card info-card-appreciation" v-if="legalInformation">
                                <div class="intro">Valider ou refuser la demande ?</div>
                                <div class="intro-item-2">Quels contrôles exercer ?</div>
                                <article>
                                    <p>{{ legalInformation.controlToBeDone }}</p>
                                </article>

                                <div class="intro-item-2">Quels fondements juridiques ?</div>
                                <div v-for="reference in legalInformation.legalReferences" :key="reference.id">
                                    <article class="before-link">{{ reference.title }}</article>
                                    <a v-bind:href="`${ reference.url }`" target="_blank">Voir l'article</a>
                                </div>
                            </div>
                            <!-- /.info-card -->

                            <div class="col-11 info-card info-card-appreciation" v-if="legalInformation">
                                <div class="intro">Renouvellement</div>
                                <div class="intro-item-2">{{ legalInformation.renewalDateInfo }}</div>

                                <article>{{ legalInformation.renewalDateText }}</article>

                                <div class="intro-item-2" v-if="exemption.nextRenewalDate">
                                    Date de renouvellement
                                </div>
                                <div v-if="exemption.nextRenewalDate">{{ exemption.nextRenewalDate | formatDate }}</div>
                            </div>
                            <!-- /.info-card -->

                            <div class="input-group col-md-10 mx-sm-auto my-md-4">
                                <button class="btn btn-success btn-lg linktoemployee appreacitionsignature"
                                        @click.prevent="openConfirmationModal"
                                >
                                    <span>Accepter</span>
                                </button>

                                <button class="btn btn-success btn-lg savepdf appreciationpdf"
                                    @click.prevent="showRejectExemptionModal"
                                >
                                    <span>Refuser</span>
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            </section>
        </div>

        <Footer></Footer>
    </div>
</template>

<script>
    import Sidebar from '../../components/Sidebar';
    import Footer from '../../components/Footer';
    import ExemptionEvaluation from '../../components/modal/ExemptionEvaluation';
    import ConfirmationModal from '../../components/modal/ConfirmationModal';
    import ExemptionManager from '../../service/manager/exemptionManager';
    import Header from '../../components/Header';
    import { required } from 'vuelidate/lib/validators';
    import { downloadFile } from '../../utils/utils';
    import { formatDate } from '../../utils/filters';
    import {
        approveExemptionById,
        fetchExemptionById,
        fetchReasonByExemptionId,
        fetchReasonLegalInformation,
        rejectExemptionById
    } from '../../service/api/exemptions.api';
    export default {
        data() {
            return {
                exemption: null,
                legalInformation: null,
                rejectReasonRequired: false,
                reason: null,
                showModal: false,
                showConfirmationModal: false,
                handledFields: {},
                rejectFormData: {
                    rejectReason: '',
                    comment: ''
                }
            };
        },
        computed: {
            exemptionId() {
                return this.$route.params.id;
            },
            documentTypes() {
                return this.reason?.documentTypes || [];
            }
        },
        async mounted() {
            await this.fetchExemption();
            await this.fetchLegalInformation();
            await this.fetchReason();
        },
        methods: {
            async fetchExemption() {
                const { data: exemption } = await fetchExemptionById(this.exemptionId);
                this.exemption = await ExemptionManager.createExemptionForAppreciation(exemption);
                this.$store.dispatch('setSettingsContext', { enterpriseUuid: exemption.enterprise.uuid });

                if (exemption.status !== 'to_validate' && exemption.status !== 'draft') {
                    await this.$router.push({ name: 'oops', params: {
                        messageShortCode: 'wrong_status_to_validate'
                    }});
                }
            },
            async fetchLegalInformation() {
                const { data: legalInformation } = await fetchReasonLegalInformation(
                    this.exemption.exemptionReason.reasonId
                );
                this.legalInformation = legalInformation;
            },
            async fetchReason() {
                const { data: reason } = await fetchReasonByExemptionId(this.exemptionId);
                this.reason = reason;
            },
            async approve() {
                this.rejectReasonRequired = false;
                await approveExemptionById(this.exemptionId);

                await this.$router.push({ name: 'success', params: {
                    messageShortCode: 'exemption_approved'
                }});
            },
            async reject() {
                this.rejectReasonRequired = true;
                await rejectExemptionById(this.exemptionId, this.rejectFormData);

                await this.$router.push({ name: 'success', params: {
                    messageShortCode: 'exemption_rejected'
                }});
            },
            hasReasonFile(code) {
                if (code === 'SD0') {
                  return !!this.exemption.document;
                }

                return this.exemption.exemptionReason.documents.some(doc => doc.typeCode === code);
            },
            downloadFileByCode(code) {
                let exemptionDocument = null;
                if (this.exemption?.document?.typeCode === code) {
                    exemptionDocument = this.exemption.document;
                }

                this.exemption.exemptionReason.documents.forEach((doc) => {
                    if (doc.typeCode === code) {
                        exemptionDocument = doc;
                    }
                });

                exemptionDocument && downloadFile(exemptionDocument);
            },
            showRejectExemptionModal() {
                window.scrollTo({ top: 0, left: 0, behaviour: 'smooth' });
                this.showModal = true;
            },
            openConfirmationModal() {
                window.scrollTo({ top: 0, left: 0, behaviour: 'smooth' });
                this.showConfirmationModal = true;
            },
        },
        validations: {
            rejectFormData: {
                rejectReason: {
                    required
                }
            }
        },
        filters: {
            formatDate
        },
        components: {
            Header,
            Sidebar,
            Footer,
            ExemptionEvaluation,
            ConfirmationModal
        }
    }
</script>

<style>
    .question {
        font-size: 16px;
    }
</style>
